import axios from "api/axios"
import { APIResponse } from "api/types"
import { formatErrorResponse, formatSuccessResponse } from "api/utils"

import { OfferLetterType } from "./types"
import { urls } from "./urls"

export default {
  list: async (): Promise<APIResponse<OfferLetterType[]>> => {
    try {
      const res = await axios.get(urls.list())
      return formatSuccessResponse(res)
    } catch (e) {
      const error = formatErrorResponse(e)
      throw error
    }
  },
}
